import React from "react";

function Homepage() {
  return <div>Homepage</div>;
}

export default Homepage;
